export default __webpack_public_path__ + "static/media/Scarecrow.63343086.png";